var _react_refresh_temp_1, _react_refresh_temp_2;
var _react_refresh_temp_3, _react_refresh_temp_4;
_react_refresh_temp_3 = $RefreshSig$();
_react_refresh_temp_4 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable i18next/no-literal-string -- Dev tools don't use translations */
import { useCallback, useMemo } from 'react';
import { Box, Button, ComboboxField, Typography, useToastService, } from '@lucidlink/uicore';
import { FormRoot, useFormRoot } from '@lucidlink/uicore/form-builder';
import { useUserWorkspaces } from '#query-hooks';
import { useWorkspaceSuspension } from './hooks';
const WorkspaceSuspensionContent = () => {
    _react_refresh_temp_3();
    const { formData: { workspaceId: selectedWorkspaceId }, methods: { reset }, } = useFormRoot();
    const { query: { data: userWorkspaces = [] }, } = useUserWorkspaces();
    const { addToast } = useToastService();
    const workspaceOptions = useMemo(() => userWorkspaces
        .filter((workspace) => !workspace.isSuspended)
        .map((workspace) => ({
        id: workspace.id,
        text: workspace.name,
    })), [userWorkspaces]);
    const handleSuccess = useCallback(() => {
        addToast({
            content: {
                message: 'Successfully suspended workspace',
            },
            kind: 'positive',
            'data-testid': 'workspace-suspension-success',
        });
        reset({});
    }, [addToast, reset]);
    const handleError = useCallback((error) => {
        addToast({
            content: {
                message: `Failed to suspend workspace: ${error instanceof Error ? error.message : 'Unknown error'}`,
            },
            kind: 'negative',
            'data-testid': 'workspace-suspension-error',
        });
    }, [addToast]);
    const { mutation: { isPending: isSuspending, mutate: suspendWorkspace }, } = useWorkspaceSuspension(selectedWorkspaceId || '', {
        onSuccess: handleSuccess,
        onError: handleError,
    });
    return (_jsxs(Box, { gap: "m", orientation: "vertical", children: [_jsx(Typography, { color: "accent", kind: "h5", children: "Workspace Suspension" }), _jsx(ComboboxField, { "data-testid": "workspace-selector", disabled: isSuspending, id: "workspaceId", isMultiselect: false, isSearchable: false, label: "Select workspace", name: "workspaceId", options: workspaceOptions, placeholder: "Select workspace..." }), _jsx(Box, { align: "center", gap: "sm", children: _jsx(Button, { "data-testid": "suspend-workspace-button", disabled: !selectedWorkspaceId, isLoading: isSuspending, kind: "secondary", onClick: () => suspendWorkspace(), children: "Suspend Workspace" }) })] }));
};
_react_refresh_temp_1 = WorkspaceSuspensionContent;
$RefreshReg$(_react_refresh_temp_1, "WorkspaceSuspensionContent");
_react_refresh_temp_3(WorkspaceSuspensionContent, "EWCZrixdBX5RCTgtGE+G7PLWJ18=", false, () => [useFormRoot, useUserWorkspaces, useToastService, useWorkspaceSuspension]);
export const WorkspaceSuspension = () => {
    _react_refresh_temp_4();
    const { query: { data: userWorkspaces = [] }, } = useUserWorkspaces();
    const initialWorkspaceId = userWorkspaces[0]?.id ?? '';
    return (_jsx(FormRoot, { "data-testid": "workspace-suspension-form", initialResetState: {
            workspaceId: initialWorkspaceId,
        }, children: _jsx(WorkspaceSuspensionContent, {}) }));
};
_react_refresh_temp_2 = WorkspaceSuspension;
$RefreshReg$(_react_refresh_temp_2, "WorkspaceSuspension");
_react_refresh_temp_4(WorkspaceSuspension, "7iPUH9AQGhS6aMSdXfMjdl/MkBU=", false, () => [useUserWorkspaces]);
